const tariffs = {
  Annual: [
    {
      minKktCount: 1,
      maxKktCount: 1,
      newPrice: 25415,
      oldPrice: 29900,
    },
    {
      minKktCount: 2,
      maxKktCount: 10,
      newPrice: 20315,
      oldPrice: 23900,
    },
    {
      minKktCount: 11,
      maxKktCount: null,
      newPrice: 19295,
      oldPrice: 22700,
    },
  ],
  Monthly: [
    {
      minKktCount: 1,
      maxKktCount: 1,
      newPrice: 2287,
      oldPrice: 2690,
    },
    {
      minKktCount: 2,
      maxKktCount: 10,
      newPrice: 1777,
      oldPrice: 2090,
    },
    {
      minKktCount: 11,
      maxKktCount: null,
      newPrice: 1692,
      oldPrice: 1990,
    },
  ]
};

export function getPrices(kktCount) {
  kktCount = parseInt(kktCount, 10);
  const result = {};
  Object.keys(tariffs).forEach(tariffName => {
    if (typeof kktCount === 'number' && kktCount > 0) {
      tariffs[tariffName].forEach(tariffParams => {
        if(kktCount >= tariffParams.minKktCount && kktCount <= tariffParams.maxKktCount) {
          result[tariffName] = {
            newPrice: tariffParams.newPrice,
            oldPrice: tariffParams.oldPrice,
          }
          return;
        }
        if(kktCount >= tariffParams.minKktCount && tariffParams.maxKktCount === null) {
          result[tariffName] = {
            newPrice: tariffParams.newPrice,
            oldPrice: tariffParams.oldPrice,
          }
          return;
        }
      });
    } else {
      result[tariffName] = {
        newPrice: tariffs[tariffName][0].newPrice,
        oldPrice: tariffs[tariffName][0].oldPrice,
      };
    }
  });
  return result;
}
